import { render, staticRenderFns } from "./EmailUpdateVerification.vue?vue&type=template&id=04f11dfc&"
import script from "./EmailUpdateVerification.vue?vue&type=script&lang=js&"
export * from "./EmailUpdateVerification.vue?vue&type=script&lang=js&"
import style0 from "./EmailUpdateVerification.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EmailUpdateVerification.vue"
export default component.exports